module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-header"
  }, [_c('div', {
    staticClass: "table-heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeWithCustomers"
    }
  }), _vm._v("\n            " + _vm._s(_vm.heading) + "\n            "), _vm._t("default")], 2)]), _vm._v(" "), (!_vm.loading) ? _c('vue-apex-charts', {
    staticClass: "graph-data-box",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.getSeries
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "465"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46c39325"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/GraphCard.vue
// module id = 856
// module chunks = 0